<template>
  <div class="modal-sm modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" v-if="user">Редактировать пользователя</h3>
        <h3 class="modal-title" v-else>Добавить пользователя</h3>
        <button type="button" class="close" @click="hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div v-if="userData" class="modal-body">
        <input-form-custom
          name="second_name"
          v-model="userData.second_name"
          label="Фамилия"
          class="mb-3"
          inputClass="form-control"
        />
        <input-form-custom
          name="first_name"
          v-model="userData.first_name"
          label="Имя"
          class="mb-3"
          inputClass="form-control"
        />
        <input-form-custom
          name="third_name"
          v-model="userData.third_name"
          label="Отчество"
          class="mb-3"
          inputClass="form-control"
        />
        <div class="form-group">
          <label>Роль</label>
          <server-select
            v-model="userData.role"
            placeholder="Выберите роль..."
            endpoint="roles"
            label="label"
            trackBy="id"
            v-validate="'required'"
            name="role"
            data-vv-as="Роль"
          />
          <div v-if="errors.first('role')" class="alert alert-danger">{{ errors.first('role') }}</div>
        </div>
        <input-form-custom
          name="email"
          v-model="userData.email"
          label="E-mail"
          :disabled="disableEmail"
          :rule="'required|email'"
          class="mb-3"
          inputClass="form-control"
        />
        <input-form-custom
          name="phone"
          v-model="userData.phone"
          label="Телефон"
          :rule="{ required: true, regex: /^\+[1-9]{1}[0-9]{10}$/ }"
          class="mb-3"
          inputClass="form-control"
        />
        <div class="form-group mb-3" v-if="$root.isAdmin()">
          <label>Организация</label>
          <server-select
            v-model="userData.region"
            label="short_name"
            endpoint="regions/options"
          />
        </div>
      </div>
      <div class="alert alert-danger my-1" v-if="validationError">
        {{validationError}}
      </div>
      <div class="modal-footer d-flex justify-content-end">
        <btn-action
          class="btn btn-primary"
          @click="save"
        >Сохранить</btn-action>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '@/api'
  import {pick, cloneDeep} from 'lodash'

  export default {
    props: ['user', 'disableEmail'],
    data () {
      return {
        userData: null,
        validationError: '',
      }
    },
    methods: {
      save () {
        this.$validator.validateAll().then(success => {
          if (success) {
            if (this.user) {
              api.put(`users/${this.user.id}`, this.userData).then(() => this.hide(true))
                .catch(this.handleError)
            } else {
              api.post('users', this.userData).then(() => this.hide(true))
                .catch(this.handleError)
            }
          }
        })
      },
      hide (refresh = false) {
        this.$emit('hide', {
          refresh: refresh,
        })
      },
      handleError (error) {
        if (error.response && error.response.status === 422) {
          let obj = error.response.data.validation
          this.validationError = obj[Object.keys(obj)[0]][0]
        } else {
          throw error
        }
      },
    },
    mounted () {
      if (this.user) {
        this.userData = pick(this.user, ['first_name', 'second_name', 'third_name', 'phone', 'email', 'role', 'region'])
      } else {
        this.userData = {
            first_name: '',
            second_name: '',
            third_name: '',
            phone: '',
            email: '',
            role: null,
            region: null,
          }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/user-modal.vue